import React from "react";
import { Link } from "react-router-dom";
import styles from "./CompassPolicy.module.css";
import { Container } from "../components/common/Container";

// Icon components
const ShieldIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
  </svg>
);

const EyeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
  </svg>
);

const CircleStackIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
  </svg>
);

const CloudIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15a4.5 4.5 0 0 0 4.5 4.5H18a3.75 3.75 0 0 0 1.332-7.257 3 3 0 0 0-3.758-3.848 5.25 5.25 0 0 0-10.233 2.33A4.502 4.502 0 0 0 2.25 15Z" />
  </svg>
);

const CubeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9" />
  </svg>
);

const BellIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
  </svg>
);

const ShareIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z" />
  </svg>
);

const UsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
  </svg>
);

const TrashIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
  </svg>
);

const LockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
  </svg>
);

const ScaleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0 0 12 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 0 1-2.031.352 5.988 5.988 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.971Zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 0 1-2.031.352 5.989 5.989 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971Z" />
  </svg>
);

const DocumentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
  </svg>
);

const EnvelopeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
  </svg>
);

const ClipboardIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25Z" />
  </svg>
);

const ArrowLeftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
  </svg>
);

const ListIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
  </svg>
);

const CheckCircleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
  </svg>
);

interface SectionProps {
  id: string;
  number: string;
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}

const Section: React.FC<SectionProps> = ({ id, number, title, icon, children }) => (
  <section id={id} className={styles.section}>
    <div className={styles.sectionHeader}>
      <div className={styles.sectionIcon}>{icon}</div>
      <div className={styles.sectionTitleWrapper}>
        <div className={styles.sectionNumber}>Section {number}</div>
        <h2 className={styles.sectionTitle}>{title}</h2>
      </div>
    </div>
    <div className={styles.sectionBody}>{children}</div>
  </section>
);

interface ListItemProps {
  children: React.ReactNode;
}

const ListItem: React.FC<ListItemProps> = ({ children }) => (
  <li className={styles.listItem}>
    <span className={styles.listBullet} />
    <span>{children}</span>
  </li>
);

const sections = [
  { id: "overview", title: "Overview" },
  { id: "data-collection", title: "Data Collection by Tier" },
  { id: "data-storage", title: "Data Storage" },
  { id: "third-party", title: "Third-Party Services" },
  { id: "notifications", title: "Push Notifications" },
  { id: "data-sharing", title: "Data Sharing" },
  { id: "children", title: "Children's Privacy" },
  { id: "data-deletion", title: "Data Deletion" },
  { id: "data-security", title: "Data Security" },
  { id: "your-rights", title: "Your Rights" },
  { id: "changes", title: "Changes to This Policy" },
  { id: "contact", title: "Contact Us" },
  { id: "summary", title: "Summary" },
];

export const CompassPolicy: React.FC = () => {
  // Update by hand whenever the policy text changes.
  const lastUpdated = "September 18, 2026";

  return (
    <main id="main-content" className={styles.page} role="main" tabIndex={-1}>
      <Container maxWidth="md">
        <Link to="/compass" className={styles.backLink}>
          <ArrowLeftIcon />
          Back to Home
        </Link>

        <header className={styles.header}>
          <div className={styles.iconWrapper}>
            <ShieldIcon />
          </div>
          <h1 className={styles.title}>Privacy Policy</h1>
          <p className={styles.subtitle}>Compass App</p>
          <div className={styles.meta}>
            <span>Last Updated: {lastUpdated}</span>
            <span className={styles.metaDot} />
            <span>iOS Application</span>
          </div>
        </header>

        <nav className={styles.toc} aria-label="Table of Contents">
          <h2 className={styles.tocTitle}>
            <ListIcon />
            Table of Contents
          </h2>
          <ul className={styles.tocList}>
            {sections.map((section, index) => (
              <li key={section.id} className={styles.tocItem}>
                <a href={`#${section.id}`} className={styles.tocLink}>
                  <span className={styles.tocNumber}>{String(index + 1).padStart(2, "0")}</span>
                  {section.title}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className={styles.content}>
          <Section id="overview" number="01" title="Overview" icon={<EyeIcon />}>
            <p>
              This privacy policy applies to the Compass mobile application
              for iOS (hereby referred to as "the App"). This policy outlines
              our practices regarding data collection, use, and sharing. This
              privacy policy is consistent with the data practices disclosed in
              the App Store privacy labels.
            </p>
            <p>
              The App offers both a free tier (local storage only) and a premium
              tier (with cloud sync). Your data handling depends on which tier
              you use.
            </p>
          </Section>

          <Section id="data-collection" number="02" title="Data Collection by Tier" icon={<CircleStackIcon />}>
            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Free Tier</h3>
              <div className={styles.notice}>
                <div className={styles.noticeIcon}>
                  <CheckCircleIcon />
                </div>
                <p><strong>Your habit data stays on your device.</strong> Your
                values, directions, habits, completions and reflections are stored
                locally only, and we do not have access to them. No account or
                personal information is required. If you allow notifications, a
                device push token is stored (see Push Notifications), and
                anonymous usage analytics are collected (see PostHog).</p>
              </div>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Premium Tier (With Account)</h3>
              <p>When you create an account for premium features, we collect:</p>
              <ul className={styles.list}>
                <ListItem>
                  <strong>Email address</strong> - Used for account identification
                  and communication
                </ListItem>
                <ListItem>
                  <strong>User ID</strong> - A unique identifier for your account
                </ListItem>
                <ListItem>
                  <strong>Authentication provider</strong> - Whether you signed in
                  with Apple, Google, or email
                </ListItem>
                <ListItem>
                  <strong>Habit data</strong> - Your values, directions, habits,
                  completions, and settings (synced to the cloud)
                </ListItem>
                <ListItem>
                  <strong>Reflections</strong> - The daily mood and optional note
                  you record in evening reflections, and any weekly summaries
                  generated from them (synced to the cloud)
                </ListItem>
                <ListItem>
                  <strong>Subscription status</strong> - Your current subscription
                  tier and expiration date
                </ListItem>
              </ul>
            </div>
          </Section>

          <Section id="data-storage" number="03" title="Data Storage" icon={<CloudIcon />}>
            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Local Storage (All Users)</h3>
              <p>
                All users have data stored locally on their device using iOS
                native storage (SwiftData). This includes:
              </p>
              <ul className={styles.list}>
                <ListItem>Values, directions, and habits</ListItem>
                <ListItem>Completion records</ListItem>
                <ListItem>Evening reflections (mood and optional note)</ListItem>
                <ListItem>App preferences and settings</ListItem>
                <ListItem>Reminder schedules</ListItem>
              </ul>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Cloud Storage (Premium Users Only)</h3>
              <p>
                Premium users who create an account have their data synced to
                secure cloud servers powered by Google Firebase (Firestore). This
                enables:
              </p>
              <ul className={styles.list}>
                <ListItem>Syncing habits across multiple devices</ListItem>
                <ListItem>Automatic backup of your data</ListItem>
                <ListItem>Data recovery if you switch devices</ListItem>
              </ul>
              <div className={styles.infoCard}>
                <p>
                  Your cloud data is encrypted in transit and at rest by Google,
                  and Firebase security rules ensure only your signed-in account
                  can read it. It is not end-to-end encrypted, which means our
                  server functions can process it to provide features such as
                  the weekly reflection summary.
                </p>
              </div>
            </div>
          </Section>

          <Section id="third-party" number="04" title="Third-Party Services" icon={<CubeIcon />}>
            <p>The App integrates with the following third-party services:</p>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Firebase (Google) - Premium Users Only</h3>
              <ul className={styles.list}>
                <ListItem>
                  <strong>Firebase Authentication</strong> - Securely manages user
                  sign-in with Apple, Google, or email/password
                </ListItem>
                <ListItem>
                  <strong>Cloud Firestore</strong> - Stores and syncs your habit
                  data and reflections across devices
                </ListItem>
                <ListItem>
                  <strong>Cloud Functions</strong> - Runs the AI features and
                  sends push notifications
                </ListItem>
                <ListItem>
                  <strong>Cloud Messaging</strong> - Delivers push notifications
                  using your device's push token (all users who allow
                  notifications)
                </ListItem>
              </ul>
              <p>
                Firebase is operated by Google. See{" "}
                <a
                  href="https://firebase.google.com/support/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.link}
                >
                  Firebase Privacy Policy
                </a>
                .
              </p>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>PostHog - Analytics</h3>
              <p>
                We use PostHog for anonymous analytics to understand how the App
                is used and improve the experience. We collect:
              </p>
              <ul className={styles.list}>
                <ListItem>App usage events (screens viewed, features used)</ListItem>
                <ListItem>Subscription events (upgrades, cancellations)</ListItem>
                <ListItem>Error events (to fix bugs)</ListItem>
              </ul>
              <p>
                Analytics data is anonymized and does not include your habit
                content or personal information. See{" "}
                <a
                  href="https://posthog.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.link}
                >
                  PostHog Privacy Policy
                </a>
                .
              </p>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Anthropic (Claude AI) - Premium Users Only</h3>
              <p>
                Two optional Premium features send data to Anthropic, Inc. for
                AI processing, through our Firebase Cloud Functions. Nothing is
                sent unless you use one of them, and your email address and
                account details are never included.
              </p>
              <ul className={styles.list}>
                <ListItem>
                  <strong>AI Coach</strong> - The messages you type, plus the
                  names of your existing values, directions, and habits so its
                  suggestions fit what you already have
                </ListItem>
                <ListItem>
                  <strong>Weekly reflection summary</strong> - That week's daily
                  moods and reflection notes, plus the names of your values
                </ListItem>
              </ul>
              <p>
                See{" "}
                <a
                  href="https://www.anthropic.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.link}
                >
                  Anthropic's Privacy Policy
                </a>
                .
              </p>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Apple Services</h3>
              <ul className={styles.list}>
                <ListItem>
                  <strong>App Store</strong> - Handles subscription payments
                </ListItem>
                <ListItem>
                  <strong>Sign in with Apple</strong> - Optional authentication
                  method
                </ListItem>
                <ListItem>
                  <strong>Push Notifications</strong> - Delivers habit reminders
                </ListItem>
              </ul>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Google Sign-In</h3>
              <p>
                If you choose to sign in with Google, Google provides your email
                and profile information to authenticate your account.
              </p>
            </div>
          </Section>

          <Section id="notifications" number="05" title="Push Notifications" icon={<BellIcon />}>
            <p>
              The App can send two kinds of notifications. Both require your
              explicit permission and can be turned off anytime in iOS Settings.
            </p>
            <ul className={styles.list}>
              <ListItem>
                <strong>Habit and reflection reminders</strong> - Scheduled
                locally on your device. No data leaves your device for these.
              </ListItem>
              <ListItem>
                <strong>Re-engagement notifications</strong> - Occasional
                messages, such as a reminder to check in, sent from our servers.
                To deliver them, the App stores your device's push token and the
                time you were last active in Firebase, along with your user ID if
                you are signed in. No habit content is included.
              </ListItem>
            </ul>
          </Section>

          <Section id="data-sharing" number="06" title="Data Sharing" icon={<ShareIcon />}>
            <div className={styles.notice}>
              <div className={styles.noticeIcon}>
                <CheckCircleIcon />
              </div>
              <p><strong>We do not sell your data.</strong></p>
            </div>
            <p>Your data may be shared only in these limited circumstances:</p>
            <ul className={styles.list}>
              <ListItem>
                <strong>Cloud sync</strong> - Premium users' data is stored on
                Firebase servers
              </ListItem>
              <ListItem>
                <strong>Analytics</strong> - Anonymous usage data is sent to
                PostHog
              </ListItem>
              <ListItem>
                <strong>AI processing</strong> - When you use the AI Coach or the
                weekly reflection summary (Premium), the data described under
                Anthropic above is sent to Anthropic for processing
              </ListItem>
              <ListItem>
                <strong>Push notifications</strong> - Your device push token is
                processed by Firebase Cloud Messaging and Apple to deliver
                notifications
              </ListItem>
              <ListItem>
                <strong>Legal requirements</strong> - If required by law or to
                protect our rights
              </ListItem>
            </ul>
            <p>
              We do not share your habit content, personal information, or data
              with advertisers or data brokers.
            </p>
          </Section>

          <Section id="children" number="07" title="Children's Privacy" icon={<UsersIcon />}>
            <p>
              The App is suitable for general audiences. Premium features
              requiring an account are intended for users aged 13 and older. For
              free tier users, no personal information is collected. For premium
              features requiring an account, users must be at least 13 years
              old.
            </p>
          </Section>

          <Section id="data-deletion" number="08" title="Data Deletion" icon={<TrashIcon />}>
            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Free Tier Users</h3>
              <p>Delete all data by uninstalling the App from your device.</p>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Premium Users</h3>
              <p>To delete your data:</p>
              <ul className={styles.list}>
                <ListItem>
                  <strong>Local data</strong> - Uninstall the App
                </ListItem>
                <ListItem>
                  <strong>Cloud data</strong> - Contact us at
                  dixonappdevelopment@gmail.com to request deletion of your cloud
                  data and account
                </ListItem>
              </ul>
              <div className={styles.infoCard}>
                <p>
                  Upon request, we will delete your account and all associated cloud
                  data within 30 days.
                </p>
              </div>
            </div>
          </Section>

          <Section id="data-security" number="09" title="Data Security" icon={<LockIcon />}>
            <p>We protect your data through:</p>
            <ul className={styles.list}>
              <ListItem>
                <strong>Local security</strong> - iOS built-in security
                features, including device passcode and biometric authentication
              </ListItem>
              <ListItem>
                <strong>Cloud security</strong> - Firebase security rules ensure
                users can only access their own data
              </ListItem>
              <ListItem>
                <strong>Encryption</strong> - Data sent to Firebase is encrypted
                in transit (HTTPS/TLS) and encrypted at rest by Google. It is not
                end-to-end encrypted.
              </ListItem>
              <ListItem>
                <strong>Authentication</strong> - Secure sign-in via Apple,
                Google, or email with password requirements
              </ListItem>
            </ul>
          </Section>

          <Section id="your-rights" number="10" title="Your Rights" icon={<ScaleIcon />}>
            <p>You have the right to:</p>
            <ul className={styles.list}>
              <ListItem>Access your data (visible within the App)</ListItem>
              <ListItem>Delete your data (see Data Deletion section)</ListItem>
              <ListItem>
                You may request to opt out of analytics where technically
                feasible.
              </ListItem>
              <ListItem>Disable push notifications (in iOS Settings)</ListItem>
              <ListItem>Cancel your subscription (in App Store settings)</ListItem>
            </ul>
          </Section>

          <Section id="changes" number="11" title="Changes to This Policy" icon={<DocumentIcon />}>
            <p>
              We may update this privacy policy from time to time. Any changes
              will be reflected in the App and on this page. We will update the
              "Last Updated" date at the top of this policy when changes are
              made. Material changes will be communicated through the App.
            </p>
          </Section>

          <Section id="contact" number="12" title="Contact Us" icon={<EnvelopeIcon />}>
            <p>
              If you have any questions or concerns about this privacy policy or
              the App, please contact us at:
            </p>
            <div className={styles.contactCard}>
              <div className={styles.contactIcon}>
                <EnvelopeIcon />
              </div>
              <div className={styles.contactDetails}>
                <p className={styles.contactLabel}>Email</p>
                <a
                  href="mailto:dixonappdevelopment@gmail.com"
                  className={styles.contactEmail}
                >
                  dixonappdevelopment@gmail.com
                </a>
              </div>
            </div>
          </Section>

          <Section id="summary" number="13" title="Summary" icon={<ClipboardIcon />}>
            <div className={styles.summary}>
              <div className={`${styles.summaryCard} ${styles.summaryCardFree}`}>
                <div className={styles.summaryCardHeader}>
                  <span className={`${styles.summaryBadge} ${styles.summaryBadgeFree}`}>
                    Free Tier
                  </span>
                </div>
                <ul className={styles.list}>
                  <ListItem>Habit data and reflections stay on your device</ListItem>
                  <ListItem>No account or personal information required</ListItem>
                  <ListItem>Anonymous analytics, and a push token if you allow notifications</ListItem>
                </ul>
              </div>

              <div className={`${styles.summaryCard} ${styles.summaryCardPremium}`}>
                <div className={styles.summaryCardHeader}>
                  <span className={`${styles.summaryBadge} ${styles.summaryBadgePremium}`}>
                    Premium Tier
                  </span>
                </div>
                <ul className={styles.list}>
                  <ListItem>Email and account data collected for sign-in</ListItem>
                  <ListItem>Habit data and reflections synced to Firebase, encrypted in transit and at rest</ListItem>
                  <ListItem>Anonymous analytics via PostHog</ListItem>
                  <ListItem>AI Coach and weekly summary data processed by Anthropic, only when you use them</ListItem>
                  <ListItem>You control your data and can request deletion</ListItem>
                </ul>
              </div>
            </div>
          </Section>
        </div>
      </Container>
    </main>
  );
};
